import { useState } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';
import {
	IconButton,
	Box,
	Flex,
	HStack,
	DrawerOverlay,
	useColorModeValue,
	DrawerBody,
	Drawer,
	DrawerContent,
	useDisclosure,
	BoxProps,
	FlexProps,
	List,
	ListItem,
	Heading,
	DrawerHeader,
	DrawerCloseButton,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import { ReactText } from 'react';

export default function Playlist() {
	const playlist = JSON.parse(localStorage.getItem('playlist')!!);
	const firstVideoId = playlist.videos[0].link.split('https://youtu.be/')[1];
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [activeVideoId, setActiveVideoId] = useState(firstVideoId);
	const [activeVideoIndex, setActiveVideoIndex] = useState(0);
	const onPlayerReady: YouTubeProps['onReady'] = (event) => {
		// access to player in all event handlers via event.target
		// event.target.pauseVideo();
	};

	const opts: YouTubeProps['opts'] = {
		width: '100%',
		playerVars: {
			// https://developers.google.com/youtube/player_parameters
			autoplay: 1,
		},
	};

	return (
		<Box bg={useColorModeValue('#202020', 'gray.900')}>
			<MobileNav onOpen={onOpen} />
			<HStack h='full' display='flex' alignItems='flex-start'>
				<SidebarContent
					onClose={() => onClose}
					setActiveVideoId={setActiveVideoId}
					activeVideoIndex={activeVideoIndex}
					setActiveVideoIndex={setActiveVideoIndex}
					display={{ base: 'none', md: 'block' }}
				/>
				<Box
					w='full'
					h='full'
					display={'flex'}
					justifyContent={'center'}
					bg={useColorModeValue('#202020', 'gray.900')}>
					<YouTube
						videoId={activeVideoId}
						opts={opts}
						onReady={onPlayerReady}
						style={{
							marginTop: '20px',
							width: '100%',
							height: '100%',
						}}
					/>
				</Box>
				;
			</HStack>
			<Drawer
				isOpen={isOpen}
				placement='left'
				onClose={onClose}
				returnFocusOnClose={false}
				onOverlayClick={onClose}>
				<DrawerOverlay />
				<DrawerContent color={'white'} bg={'#1e1e1e'}>
					<DrawerCloseButton />
					<DrawerHeader>Playlist</DrawerHeader>
					<DrawerBody>
						{playlist.videos.map((video: any, idx: any) => (
							<Box
								// bg={idx === active ? '#444444' : ''}
								onClick={() => {
									setActiveVideoId(
										video.link.split('https://youtu.be/')[1]
									);
									setActiveVideoIndex(idx);

									onClose();
								}}
								m='5px 0'
								rounded='md'
								cursor='pointer'
								p={2}
								bg={
									idx === activeVideoIndex
										? '#0d47a1'
										: '#2a2a2a'
								}
								_hover={{
									bg: '#444444',
								}}>
								{video.title}
							</Box>
						))}
						{/* <SidebarContent onClose={onClose} /> */}
					</DrawerBody>
				</DrawerContent>
			</Drawer>
			{/* mobilenav */}
			<Box ml={{ base: 0, md: 60 }} p='4'></Box>
		</Box>
	);
}

interface SidebarProps extends BoxProps {
	onClose: () => void;
	setActiveVideoId: (id: ReactText) => void;
	activeVideoIndex: number;
	setActiveVideoIndex: (idx: number) => void;
}

const SidebarContent = ({
	onClose,
	setActiveVideoId,
	activeVideoIndex,
	setActiveVideoIndex,
	...rest
}: SidebarProps) => {
	const playlist = JSON.parse(localStorage.getItem('playlist')!);
	return (
		<Box
			transition='3s ease'
			bg={useColorModeValue('#1a1a1a', 'gray.900')}
			borderRight='1px'
			w={{ base: 'full', md: 80 }}
			{...rest}>
			<List color={'white'} p={2}>
				{playlist.videos.map((video: any, idx: any) => (
					<ListItem
						onClick={() => {
							setActiveVideoId(
								video.link.split('https://youtu.be/')[1]
							);
							setActiveVideoIndex(idx);
						}}
						m={'0px 10px 10px 10px'}
						rounded='md'
						cursor='pointer'
						p={2}
						bg={idx === activeVideoIndex ? '#0d47a1' : '#2a2a2a'}>
						{video.title}
					</ListItem>
				))}
			</List>
		</Box>
	);
};

interface MobileProps extends FlexProps {
	onOpen: () => void;
}
const MobileNav = ({ onOpen, ...rest }: MobileProps) => {
	// get userInfo from localStorage
	const playlist = JSON.parse(localStorage.getItem('playlist')!);
	return (
		<Flex
			// ml={{ base: 0, md: 60 }}
			// px={{ base: 4, md: 4 }}
			height='20'
			alignItems='center'
			bg={useColorModeValue('#1a1a1a', 'gray.900')}
			color='#adadad'
			justifyContent={{ base: 'space-between', md: 'flex-end' }}
			{...rest}>
			<IconButton
				display={{ base: 'flex', md: 'none' }}
				onClick={onOpen}
				variant='outline'
				aria-label='open menu'
				icon={<FiMenu />}
			/>

			<Heading
				w='full'
				color={'wheat'}
				fontSize='xl'
				textAlign={'center'}>
				{playlist.title}
			</Heading>
		</Flex>
	);
};
